export const onInitialized = () => {
	return {
		restrict: 'A',
		priority: 1000, // to ensure that the postLink run last.
		link: function postLink(scope, element, attrs) {
			if (typeof window[attrs.onInitialized] == 'function') {
				window[attrs.onInitialized]();
			}
		}
	};
};
